import React, { FC } from "react";
import { Grid, Typography, CardContent, Card } from "e100-react-components";
import { useStyles } from "./styles";
import { Icon } from "components";
import { Props as IconProps } from "components/Icon";

interface CardProps {
  primaryText: string;
  secondaryText: string;
  iconKind: IconProps["kind"];
}
export const StatisticCard: FC<CardProps> = ({
  primaryText,
  secondaryText,
  iconKind,
}) => {
  const classes = useStyles();
  return (
    <Card
      classes={{
        root: classes.container,
      }}
    >
      <CardContent
        classes={{
          root: classes.cardContent,
        }}
      >
        <Grid container>
          <Grid item>
            <Grid
              container
              wrap={'nowrap'}
            >
              <Grid item>
                <Icon
                  kind={iconKind}
                  color="secondary"
                  classes={{ root: classes.icon}}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle2" color="textPrimary">
                  <span dangerouslySetInnerHTML={{ __html: primaryText }} />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="secondary">
              {secondaryText}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
